export * from './search-page-map.module';
